import distanceLimit from '@/view/distanceLimit/index'
import storeMap from '@/view/distanceLimit/storeMap'

export default [
  {
    path: '/distanceLimit',
    component: distanceLimit,
    meta: {
      title: '问诊离店限制',
    },
  },
  {
    path: '/distanceLimit/storeMap',
    component: storeMap,
    meta: {
      title: '设置门店位置',
    },
  },
]
